(function (window, $) {
  /**
   * Do nothing
   *
   * @returns {undefined}
   */
  function noop() {}

  // soulcup/analytics.js might have not been loaded.
  // Initialization is deferred if it has not been loaded
  var analytics = {
    track: noop
  };

  var $landing = $('.soulcup-landing-main');
  if ($landing.length) {
    initLanding();

    var isRiderEnrolled = !!$landing.data('is-enrolled');
    loadAnalyticsManager(isRiderEnrolled);
  }

  function initLanding() {
    var headerHeight = $('.header-container').height();
    $('.more-info-item a, a.arrow-down').click(function (e) {
      e.preventDefault();
      var linkTo = '#' + this.href.split('#').pop();
      var offset = 1;
      var scrollTo = $(linkTo).offset().top - headerHeight + offset;

      $('html, body').animate({
        scrollTop: scrollTo
      }, 500);
    });

    $('.soulcup-share-icon-link').on('click', function () {
      var shareLinkInput = document.getElementsByClassName('soulcup-share-links__share-link')[0];
      copyToClipboard(shareLinkInput);
    });

    $('.soulcup-landing-main .register-btn').on('click', function () {
      var eventName = $landing.data('is-enrolled') ? 'Click View Turn It UP Challenge Dashboard' : 'Click Join Turn It UP Challenge';
      analytics.track(eventName, 'Landing');
    });

    $('.soulcup-share-icon-ios').on('click', function () {
      analytics.track('Click Download App', 'Landing');
    });
  }

  function copyToClipboard(input) {
    input.style.display = 'block';
    input.select();
    input.setSelectionRange(0, input.value.length);
    // copy the selection
    var succeed = false;
    try {
      succeed = document.execCommand('copy');
    } catch (e) {
      succeed = false;
    }
    input.style.display = 'none';
    if (succeed) {
      confirmation(null, 'Link copied to clipboard');
    }
  }

  /**
   * Load the analytics manager whenever it is ready
   *
   * @param {boolean} isEnrolled is rider enrolled in campaign
   * @returns {undefined}
   */
  function loadAnalyticsManager(isEnrolled) {
    /**
     * Do the actual loading
     *
     * @returns {undefined}
     */
    function doLoad() {
      if (typeof window.SC !== 'undefined' && typeof window.SC.soulcupAnalytics !== 'undefined' && typeof window.SC.soulcupAnalytics.createAnalyticsManager) {
        analytics = window.SC.soulcupAnalytics.createAnalyticsManager('Landing', {
          'Enrollment Status': isEnrolled ? 'Enrolled' : 'Unenrolled'
        });
        analytics.track('View Screen', 'Landing');
        return;
      }

      // Try again after 200 ms if analytics was not yet available
      setTimeout(loadAnalyticsManager, 200);
    }

    doLoad();
  }
})(window, jQuery);
